import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getLicenseTypes} from 'src/openapi/admin/apis/GetLicenseTypesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectLicenseTypes} from './services/dictionary-slice';

export const useLicenseTypes = () => {
    const apiDispatch = useAppDispatch();
    const licenseTypes = useSelector(selectLicenseTypes);

    const loadLicenseTypes = useCallback(() => {
        if (!licenseTypes.length) {
            apiDispatch(getLicenseTypes());
        }
    }, [licenseTypes.length, apiDispatch]);

    const getLicenseTypeByCode = useCallback((code: string) => {
        return licenseTypes.find(e => e.code === code)?.description;
    }, [licenseTypes]);

    return {licenseTypes, loadLicenseTypes, getLicenseTypeByCode};
};
